import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs";
import { InvocationHealthSchedulesRoute } from "../../routing/IndividualRoutes";

export class InvocationHealthSchedulesPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <InvocationHealthSchedulesRoute />
            </Fragment>
        );
    }
}
